import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface FreezeHistory {
  startDate: string;
  endDate: string;
  note: string;
  creator: string;
  creationDate: string;
  actions: string;
}

export interface FreezeHistoryDialogData {
  subscriptionId?: number;
  freezes?: FreezeHistory[];
}

@Component({
  selector: "app-freeze-history",
  templateUrl: "./freeze-history.component.html",
  styleUrls: ["./freeze-history.component.scss"],
})
export class FreezeHistoryComponent implements OnInit {
  freezes: FreezeHistory[] = [];

  constructor(
    private dialogRef: MatDialogRef<FreezeHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FreezeHistoryDialogData,
  ) {}

  ngOnInit(): void {
    if (this.data?.freezes) {
      this.freezes = this.data.freezes;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
